import React from "react";
import PropTypes from "prop-types";
// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Loader from "react-loader";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

import UploadStep1 from "./WizardSteps/UploadStep1.jsx";
//import Step2 from "./WizardSteps/Step2.jsx";
//import Step3 from "./WizardSteps/Step3.jsx";
import { withStyles } from "@material-ui/core/styles";

import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import { dev, prod } from "../../config/config";
class WizardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: true,
      alert: null,
      show: false,
      config: prod
    };
    this.handleFinish = this.handleFinish.bind(this);
    this.updateAd = this.updateAd.bind(this);
    this.adNewAd = this.adNewAd.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.titleAndTextAlert = this.titleAndTextAlert.bind(this);
    this.isFailed = this.isFailed.bind(this);
  }

  componentDidMount() {
    if (
      firebase.auth().currentUser &&
      firebase.auth().currentUser.email === "dev_admin@proledgers.com"
    ) {
      this.setState({
        config: dev
      });
    }
  }
  isFailed = () => {
    this.titleAndTextAlert("Select Image", "Image isn't Selected!");
  };
  handleFinish = state => {
    if (this.props.update) {
      this.updateAd(state);
    } else {
      this.adNewAd(state);
    }
  };

  handleCancel = () => {
    this.props.handleCancel();
  };

  adNewAd = state => {
    if (state[0].create_ad.file) {
      const file = state[0].create_ad.file;
      var imageRef =
        this.state.config.STORAGE_ADS + "/" + Date.now() + file.name;
      this.setState({
        loaded: false
      });
      this.uploadImage(file, imageRef).then(downloadUrl => {
        firebase
          .firestore()
          .collection(this.state.config.DB_Ads)
          .add({
            description: state[0].create_ad.description,
            redirect_url: state[0].create_ad.redirect_url,
            type: state[0].create_ad.type,
            image_url: downloadUrl,
            image_ref: imageRef,
            ad_space: this.props.ad_space,
            time: Date.now(),
            update_id: 0
          })
          .then(() => {
            this.setState({ loaded: true });
            this.props.handleFinish(state);
          });
      });
    } else {
      this.setState({ loaded: true });
      this.titleAndTextAlert("Select Image", "Image isn't selected");
    }
  };

  updateAd = state => {
    this.setState({
      loaded: false
    });
    if (state[0].create_ad.file) {
      const file = state[0].create_ad.file;
      var imageRef =
        this.state.config.STORAGE_ADS + "/" + Date.now() + file.name;
      const previousImageRef = state[0].create_ad.image_ref;
      this.deleteImage(previousImageRef).then(() => {
        this.uploadImage(file, imageRef).then(downloadUrl => {
          firebase
            .firestore()
            .collection(this.state.config.DB_Ads)
            .doc(state[0].create_ad.ad_id)
            .update({
              description: state[0].create_ad.description,
              redirect_url: state[0].create_ad.redirect_url,
              update_id: state[0].create_ad.update_id + 1,
              image_url: downloadUrl,
              type: state[0].create_ad.type,
              image_ref: imageRef
            })
            .then(() => {
              this.setState({ loaded: true });
              this.props.handleFinish(state);
            });
        });
      });
    } else {
      firebase
        .firestore()
        .collection(this.state.config.DB_Ads)
        .doc(state[0].create_ad.ad_id)
        .update({
          description: state[0].create_ad.description,
          redirect_url: state[0].create_ad.redirect_url,
          update_id: state[0].create_ad.update_id + 1,
          type: state[0].create_ad.type
        })
        .then(() => {
          this.setState({ loaded: true });
          this.props.handleFinish(state);
        });
    }
  };

  uploadImage = (file, imageRef) => {
    var storageRef = firebase
      .storage()
      .ref()
      .child(imageRef);
    return storageRef.put(file).then(snapshot => {
      return snapshot.ref.getDownloadURL().then(downloadUrl => {
        return downloadUrl;
      });
    });
  };

  deleteImage = imageRef => {
    var storageRef = firebase
      .storage()
      .ref()
      .child(imageRef);
    return storageRef.delete();
  };

  titleAndTextAlert(title, detail) {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={title}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.info
          }
        >
          {detail}
        </SweetAlert>
      )
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  render() {
    const {
      //classes,
      adData,
      update,
      ad_space,
      requiredHeight,
      requiredWidth
    } = this.props;
    return (
      <div>
        {this.state.alert}
        <GridContainer justify="center">
          <GridItem xs={12} sm={8}>
            <Loader loaded={this.state.loaded}>
              <Wizard
                validate
                steps={[
                  {
                    stepName: "Ad Details",
                    stepComponent: UploadStep1,
                    stepId: "create_ad"
                  }
                  //{ stepName: "Account", stepComponent: Step2, stepId: "account" },
                  // { stepName: "Address", stepComponent: Step3, stepId: "address" }
                ]}
                title="Manage ad"
                subtitle={update ? "Update Ad" : "Create New Ad"}
                adData={adData}
                update={update}
                ad_space={ad_space}
                requiredWidth={requiredWidth}
                requiredHeight={requiredHeight}
                isFailed={this.isFailed}
                finishButtonText={update ? "Update" : "Add"}
                finishButtonClick={this.handleFinish}
                cancelButtonClick={this.handleCancel}
              />
            </Loader>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Wizard.propTypes = {
  handleFinish: PropTypes.func,
  handleCancel: PropTypes.func,
  requiredHeight: PropTypes.number,
  requiredWidth: PropTypes.number
  //ad_space: PropTypes.string.isRequired
};
export default withStyles(sweetAlertStyle)(WizardView);



// WEBPACK FOOTER //
// ./src/views/Forms/Wizard.jsx